import React from 'react';
import ObjectiveCard from '../objectiveCard';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CourseCard from '../courseCard';
import { Copy } from '@salesperformanceint/e4shared';
import posthog from 'posthog-js';

export const Completed = ({ history, text, objectives }) => {
    const { exploreAsideOpen } = useSelector(state => state.ui);

    if (objectives?.length === 0) {
        return (
            <div className="no-results">
                <Copy value={text.noResults.completed} />
            </div>
        );
    }

    return (
        <div>
            {objectives
                .filter(x => x.type === 'lms')
                .map(o => (
                    <CourseCard key={`course-${o.id}`} text={text} course={o} />
                ))}
            {objectives
                .filter(x => x.type === 'task')
                .sort((a, b) => (a.date_Completed < b.date_Completed ? 1 : -1))
                .map(o => (
                    <ObjectiveCard
                        key={`objective-${o.id}`}
                        text={text}
                        objective={o}
                        profileId={exploreAsideOpen.profileId}
                    />
                ))}
            {objectives?.length > 0 && (
                <div className="pull-right">
                    <button
                        data-testid="button-view-all"
                        className="btn btn-primary"
                        onClick={() => {
                            history.push(`/objectives/${exploreAsideOpen.profileId}`);
                            posthog.capture('explore menu - clicked view all objectives');
                        }}
                    >
                        {text.buttons.viewAllObjectives}
                    </button>
                </div>
            )}
        </div>
    );
};

export default withRouter(Completed);
